const gradientStops = [
  { offset: 0, red: 47, green: 184, blue: 232 },
  { offset: 35, red: 126, green: 71, blue: 155 },
  { offset: 70, red: 216, green: 76, blue: 103 },
  { offset: 100, red: 245, green: 178, blue: 92 },
];

export const gradientAtPositionSelector = (numerator, denominator) => {
  let offset = (numerator / denominator) * 100;

  let index;
  for (index = 0; index < gradientStops.length - 1; index++) {
    if (offset < gradientStops[index + 1].offset) {
      break;
    }
  }

  if (index === gradientStops.length - 1) {
    return {
      red: gradientStops[index].red,
      green: gradientStops[index].green,
      blue: gradientStops[index].blue,
    };
  }

  let weight = 0;
  if (gradientStops[index + 1].offset - gradientStops[index].offset !== 0) {
    weight = (offset - gradientStops[index].offset) / (gradientStops[index + 1].offset - gradientStops[index].offset);
  }

  return weightedDistanceBetweenTwoColors(
    gradientStops[index],
    gradientStops[index + 1],
    weight
  );
};

export const rgbAtPositionSelector = (numerator, denominator) => {
  let position = (numerator / denominator) * 100;
  let startColorIndex = gradientStops.findIndex((stop, i, stops) => {
    return i === stops.length - 1 || stop.offset <= position && stops[i + 1].offset > position;
  });

  if (startColorIndex === -1) {
    // If position is out of range of gradient stops, return the last color
    startColorIndex = gradientStops.length - 1;
  }

  // Directly return the color at the last index or exact position match
  if (startColorIndex === gradientStops.length - 1 || gradientStops[startColorIndex].offset === position) {
    return {
      red: gradientStops[startColorIndex].red,
      green: gradientStops[startColorIndex].green,
      blue: gradientStops[startColorIndex].blue
    };
  }

  // Interpolate between the closest colors
  const colorStopBefore = gradientStops[startColorIndex];
  const colorStopAfter = gradientStops[startColorIndex + 1];
  const weight = (position - colorStopBefore.offset) / (colorStopAfter.offset - colorStopBefore.offset);
  return weightedDistanceBetweenTwoColors(colorStopBefore, colorStopAfter, weight);
};

const weightedDistanceBetweenTwoColors = (color1, color2, weight) => {
  const red = parseInt(color1.red + (color2.red - color1.red) * weight);
  const green = parseInt(color1.green + (color2.green - color1.green) * weight);
  const blue = parseInt(color1.blue + (color2.blue - color1.blue) * weight);
  return { red: red, green: green, blue: blue };
};
